import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { HostComponent } from './components/host.component';
import { LaddaDirective } from './directive/ladda.directive';
import { NgxDataTableDirective } from './directive/ngx-datatable.directive';
import { NgxDatatable2Directive } from './directive/ngx-datatable2.directive';
import { ProhibitScientificNotationDirective } from './directive/prohibit-scientific-notation.directive';

@NgModule({
  declarations: [
    HostComponent,
    LaddaDirective,
    NgxDataTableDirective,
    NgxDatatable2Directive,
    ProhibitScientificNotationDirective
  ],
  imports: [CommonModule, RouterModule],
  exports: [
    HostComponent,
    LaddaDirective,
    NgxDataTableDirective,
    NgxDatatable2Directive,
    ProhibitScientificNotationDirective
  ]
})
export class DynamicFormCommonModule {}
